// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1y-Vm","overflowing":"ReadFullNote_overflowing__1EfVA"};